import { BrowserRouter, Routes, Route, Navigate, Redirect } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import LoginContainer from "./Containers/LoginContainer";
import ForgetPasswordContainer from "./Containers/ForgetPasswordContainer";
import NotFound from "./Pages/NotFoundPage";
import DashboardContainer from "./Containers/DashboardContainer";
import CoursesContainer from "./Containers/CoursesContainer";
import StudentsContainer from "./Containers/StudentsContainer";
import IntroductionContainer from "./Containers/IntroductionContainer";
import ChatContainer from "./Containers/ChatContainer";
import NewsContainer from "./Containers/NewsContainer";
import DownloadedNewsContainer from "./Containers/DownloadedNewsContainer";
import IMailContainer from "./Containers/IMailContainer";
import ProtectedRoute from "./ProtectedRoute";
import EditContainer from "./Containers/EditContainer";

const PageRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginContainer />} />
        <Route path="/forget-password" element={<ForgetPasswordContainer />} />
        <Route path="/dashboard" element={<ProtectedRoute>
          <DashboardContainer />
        </ProtectedRoute>
        } />
        <Route path="/courses" element={<ProtectedRoute>
          <CoursesContainer />
        </ProtectedRoute>} />
        <Route path="/news" element={<ProtectedRoute>
          <NewsContainer />
        </ProtectedRoute>} />
        <Route path="/downloadedNews" element={<ProtectedRoute>
          <DownloadedNewsContainer />
        </ProtectedRoute>} />
        <Route path="/students" element={<ProtectedRoute>
          <StudentsContainer />
        </ProtectedRoute>} />
        <Route path="/iMail" element={<ProtectedRoute>
          <IMailContainer />
        </ProtectedRoute>} />
        <Route path="/introduction" element={<ProtectedRoute>
          <IntroductionContainer />
        </ProtectedRoute>} />
        <Route path="/editProfile" element={<ProtectedRoute>
          <EditContainer />
        </ProtectedRoute>} />

        <Route path="/chats" element={<ProtectedRoute>
          <ChatContainer />
        </ProtectedRoute>} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" />} />

        {/* <Redirect to="/404" /> */}
        {/* <Route path="/" element={<Navigate to="/login" />} /> */}
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        draggable={false}
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
      />
    </BrowserRouter>
  );
};

export default PageRouter;
